import React, { useMemo } from 'react';
import cn from 'classnames';
import { DisparityOpportunityDescriptionInputs } from 'libs/end-to-end/src/disparity-opportunity-description-inputs';
import { LightTooltip } from 'apps/sigma2-ui/src/components/ui/Tooltip';
import { SimilarQualitiesExplanation } from 'apps/sigma2-ui/src/components/SimilarQualitiesExplanation';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DisparityOpportunityDescription = (
  props: DisparityOpportunityDescriptionInputs,
) => {
  const language = useLanguage();
  const description = useMemo(() => {
    return language.analyzeBiasDescription(props);
  }, [props, language]);

  const superscriptContent = (
    <SimilarQualitiesExplanation
      controlVariableDisplayNames={props.controlVariableDisplayNames}
    />
  );

  return (
    <div>
      {description.map((component, index) => {
        const textPart = (
          <span
            key={index}
            className={cn({
              'font-bold': component.isBold,
              'text-gray-900': component.color === 'black',
              'text-royal-600': component.color === 'blue',
              'text-purple-700': component.color === 'purple',
              'decoration-dotted underline underline-offset-[3px] decoration-gray-400':
                component.isDottedUnderline,
            })}
          >
            {component.text}
          </span>
        );

        if (component.isSuperscript) {
          return (
            <LightTooltip
              key={index}
              followCursor={true}
              title={superscriptContent}
            >
              {textPart}
            </LightTooltip>
          );
        }

        return textPart;
      })}
    </div>
  );
};
